import React from "react";
import { Delegator } from "types";
import { AccountListModal } from "@/components/Common/AccountListModal";
import { useAccount } from "@/hooks/useAccount";
import { useSwitchDelegator } from "@/hooks/useSwitchDelegator";

interface OpenAccountModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const OpenAccountModal = ({ isOpen, onClose }: OpenAccountModalProps) => {
    const { data } = useAccount();
    const { switchDelegator } = useSwitchDelegator();

    if (!data?.delegators) {
        return null;
    }

    const handleSelect = async (delegator: Delegator) => {
        onClose();
        await switchDelegator(delegator);
    };

    return (
        <AccountListModal
            title="Open Account"
            delegators={data.delegators}
            isOpen={isOpen}
            onClose={onClose}
            onSelect={handleSelect}
        />
    );
};
